import MenuLeft from '../../components/cabinets/menuleft';
import BottomNavZdo from '../../components/cabinets/BottomNavZdo';

import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { config } from './data/config';

import { getUserInfo } from '../../services/apiClient';

import Users from './components/Users/Users';
import StatisticaQueueKg from './components/Statistica/StatisticaQueueKg/StatisticaQueueKg';
import StatisticaBenefits from './components/Statistica/StatisticaPilgi/statistica_pilgi';
import StatisticaPersonal from './components/Statistica/StatisticaPersonal/StatisticaPersonal';
import StatisticaInvites from './components/Statistica/StatisticaInvites/Statistica_invites';
import StatisticaGroups from './components/Statistica/StatisticaGroups/Statistica_groups';
import StatisticaBFN from './components/Statistica/StatisticaBFN/StatisticaBFN';
import StatisticaChildrensComponent from './components/Statistica/StatisticaChildrens/statistica_childrens';
import Statistica from './components/Statistica/Statistica/statistica';
import AddKindergarten from './components/AddKindergarten/AddKindergarten';
import ShowInfoApprovedBenefits from './components/InfoApproved/showInfoApprovedBenefits';
import ShowChildren from './components/ChildInfo/showchildren';
import StaffPage from './components/Statistica/StatisticaStaff/StaffPage';
import EditModeDouKG from './components/EditKindergartens/editkindergartens';
import ApplicationsPage from '../kindergartens/detail/components/ApplicationsList/ApplicationsList';
import PositionsList from '../kindergartens/detail/components/Dictionary/TypePositions/PositionsList';
import StaffCalculationRules from '../kindergartens/detail/components/StaffCalculationRules/StaffCalculationRules';
import DocumentTypesList from '../kindergartens/detail/components/Dictionary/TypeDocuments/DocumentTypesList';
import Roles from './components/Roles/Roles';
import KitchenManagement from './components/Kitchenmanagment/KitchenManagement';
import MoneyFollowsChild from './components/MoneyFollowsChild/MoneyFollowsChild';
import SMSNotifications from './components/SMSNotifications/SMSNotifications';
import K85StatBoard from './components/K85StatBoard/K85StatBoard';
import CheckInfoAboutRegistrationKyiv from './components/CheckInfoAboutRegistrationKyiv/CheckInfoAboutRegistrationKyiv';
import ShowMessagesForModeration from './components/ShowMessagesForModeration/ShowMessagesForModeration';
import StatisticaGroupsAttends from './components/Statistica/StatisticaAttends/StatisticaGroupsAttends';
import AcademicYearsList from '../kindergartens/detail/components/Dictionary/AcademicYearsList/AcademicYearsList';
import GroupPlaceTypesList from '../kindergartens/detail/components/Dictionary/GroupPlaceTypes/GroupPlaceTypesList';
import SpecList from './components/DictSpecializations/SpecList';
import DiseasesList from './components/DictDisiases/DiseasesList';
import ApplicationCard from '../cabinet/Application/ApplicationCard';
import WizPlain from '../cabinet/wizplain';
import { getEmptyData } from '../cabinet/wizplain/data/emptyform';

import EmailChangeComponent from './components/ChangeEmail/EmailChangeComponent';
import FirstDateChangeComponent from './components/FirstDateChangeComponent/FirstDateChangeComponent';
import InvitePlans from './components/InvitePlans/inviteplans';
import NewsCategoriesPage from './components/News/NewsCategoriesPage';
import NewsAdmin from '../kindergartens/detail/components/News/NewsAdmin';


const CabinetPage = () => {

  const [activeView, setPart]   = useState();
  const [badges,     setBadges] = useState({});
  const [isEdit,     setIsEdit] = useState(false);
  const [dataEdit,   setDataEdit]       = useState(getEmptyData());
  const [dictionaryAddress, setDictionary] = useState({});

  const userInfo = getUserInfo();
  const userRole = userInfo?.privilegedUser?.role || '';

  const { menuItems, level2Items, additionalLinks, title, cabinetName, rightPossible } =
    config.cabinetMenu[userRole] || {};


  const renderChildrenComponent = () => {
    switch (activeView) {
      case 'groups':
      case 'groups_actual':
        return <StatisticaGroups isArchive={false} id='dou_act' />;
      case 'attends':
        return <StatisticaGroupsAttends />;
      case 'groups_arch':
        return <StatisticaGroups isArchive={true} id='dou_arch' />;
      case 'users':
        return <Users />;
      case 'queue_kg':
        return <StatisticaQueueKg />;
      case 'benefits':
        return <StatisticaBenefits />;
      case 'personal':
        return <StatisticaPersonal />;
      case 'invites':
        return <StatisticaInvites />;
      case 'bfn':
        return <StatisticaBFN />;
      case 'child':
        return <StatisticaChildrensComponent />;
      case 'queue':
        return <Statistica />;
      case 'messages':
        return <ShowMessagesForModeration />;
      case 'kindergartens':
      case 'addKindergarten':
        return <AddKindergarten />;
      case 'infoApprovedBenefits':
        return <ShowInfoApprovedBenefits />;
      case 'showChildren':
        return <ShowChildren />;
      case 'staff_zdo':
        return <StaffPage />;
      case 'editKindergarten':
        return <EditModeDouKG />;
      case 'orderlist':
        return (
          <ApplicationsPage
            mode={rightPossible.mode.application}
            userRole={userRole}
          />
        );
      case 'orderNew':
        return (
          <ApplicationsPage
            mode={rightPossible.mode.application}
            isMy={true}
            newApplication={() => setPart('application_card')}
            onEdit={(data) => { setDataEdit(data); setIsEdit(true); setPart('application_card'); }}
          />
        );
      case 'proffessions':
        return <PositionsList />;
      case 'staffRulles':
        return <StaffCalculationRules />;
      case 'dict_docs':
        return <DocumentTypesList />;
      case 'roles':
        return <Roles />;
      case 'kitchen':
        return <KitchenManagement />;
      case 'finans':
        return <MoneyFollowsChild />;
      case 'smsnotif':
        return <SMSNotifications />;
      case 'reports':
        return <K85StatBoard />;
      case 'checkRegKyiv':
        return <CheckInfoAboutRegistrationKyiv />;
      case 'years_dict':
        return <AcademicYearsList isEditPossible={rightPossible?.dictionaryEdit?.years} />;
      case 'dict_places':
        return <GroupPlaceTypesList />;
      case 'disct_spec':
        return <SpecList />;
      case 'disct_diss':
        return <DiseasesList />;
      case 'emailchange':
        return <EmailChangeComponent />;
      case 'firstDate':
        return <FirstDateChangeComponent />;
      case 'inviteplans':
        return <InvitePlans />
      case 'application_card':
        return (
          <WizPlain
            onFinish={() => { setDataEdit({}); setIsEdit(false); setPart('orderNew'); }}
            isEdit={isEdit}
            data={dataEdit}
            dictionary={dictionaryAddress}
            step={1}
            setPersData={() => {}}
            setPersStep={() => {}}
            isPrivelegedUser={true}
          />
        );
      case 'newsCategories':
        return <NewsCategoriesPage />
      case 'newsAdmin':
        return <NewsAdmin scope="portal" />
      default:
        return null;
    }
  };


  return (
    <div className="profile-page">
      <main className="main-content">
        <Container fluid>
          <Row>
            {/* Left Sidebar — ховається на мобільному через CSS в BottomNavZdo.css */}
            <Col md={2} className="sidebar d-none d-md-block">
              <MenuLeft
                badges={badges}
                onMenuItemClick={setPart}
                activeItem={activeView}
                onAddGroup={() => {}}
                data={{ menuItems, level2Items, additionalLinks, title }}
                cabinet={{ label: cabinetName }}
              />
            </Col>

            {/* Main Content */}
            <Col xs={12} md={10} className="main-content-area">
              {renderChildrenComponent()}
            </Col>
          </Row>
        </Container>
      </main>

      {/* Bottom Navigation — видима тільки на мобільному через CSS */}
      <BottomNavZdo
        menuItems={menuItems        || []}
        level2Items={level2Items    || {}}
        additionalLinks={additionalLinks || []}
        activeItem={activeView}
        badges={badges}
        onMenuItemClick={setPart}
        onAddGroup={() => {}}
        title={title}
        rightPossible={rightPossible || {}}
      />
    </div>
  );
};

export default CabinetPage;